import React from 'react'
import "./login.css"
import { NavLink } from 'react-router-dom';

function Login() {
  return (
    <div>
      <div class="ian-container">
      <div class="ian-container-left">
        <div class="ian-content">
          <div class="ian-header">
            <NavLink to="/" className="navlink">
            <span class="ian-back-btn">
              <i class="ri-arrow-left-line"></i>
            </span>
            </NavLink>
            
            <NavLink to="/register" className="navlink"><span class="ian-register"> Register </span></NavLink>
          </div>
          <div class="ian-form-content">
            <h3 class="ian-form-title">Login</h3>
            <p class="ian-form-subtitle">
              Welcome! Please fill your username and password to sign in to your
              account.<br/>
              <span className='mobile-registration'> <span className='or'> Or </span>
     <NavLink to="/register" className="navlink"><span class="ian-register"> Register </span></NavLink></span>
            </p>
            <form action="">
              <input type="text" placeholder="Username" class="ian-input" required/>
              <input type="password" placeholder="Password" class="ian-input" required/>
              <p class="ian-forgot-password">Forgot your password</p>
              <button class="ian-submit-btn" type="submit">Login Now</button>
            </form>
            <span class="ian-bottom-line"></span>
            <p class="ian-footer-title">You can also login with:</p>
            <div class="ian-social-icons">
              <i class="ri-facebook-box-fill"></i>
              <i class="ri-google-fill"></i>
              <i class="ri-twitter-fill"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="ian-container-rightLogin">
        <div class="ian-image">
          <h3>Start your journey</h3>
          <p>
            Start creating your amazing home with us! Login into your account.
          </p>
        </div>
      </div>
    </div>
    </div>
  )
}

export default Login
